import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test-shop',
  templateUrl: './test-shop.component.html',
  styleUrls: ['./test-shop.component.scss']
})
export class TestShopComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
